import { motion } from "framer-motion";
import { SearchCheck, Rocket, TrendingUp, Workflow } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Audit & Strategy",
    desc: "We dig into your numbers, market and message, then hand you a clear growth roadmap.",
    icon: SearchCheck,
  },
  {
    n: "02",
    title: "Build & Launch",
    desc: "Campaigns, creative and funnels go live — fast, clean and built to convert.",
    icon: Rocket,
  },
  {
    n: "03",
    title: "Optimize & Scale",
    desc: "Weekly testing and optimization. What wins gets more budget, what loses gets cut.",
    icon: TrendingUp,
  },
  {
    n: "04",
    title: "Systems & Automation",
    desc: "CRM, email/SMS flows and dashboards that keep capturing value while you sleep.",
    icon: Workflow,
  },
];

export const HowWeWork = () => (
  <section data-testid="how-we-work" className="border-y border-slate-200 bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-skybrand"
      >
        Process
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl md:text-5xl"
      >
        How We Work
      </motion.h2>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`how-we-work-step-${i}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative rounded-2xl border border-slate-200/80 bg-[#FAFAFD] p-7"
          >
            <div className="flex items-center justify-between">
              <span className="font-mono text-xs font-semibold tracking-[0.25em] text-kinetic">{s.n}</span>
              <s.icon size={22} className="text-skybrand" />
            </div>
            <h3 className="mt-8 font-display text-lg font-bold text-slate-900">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
